import { ProjectCallsInsightLevel } from "@prisma/client";

export type CallAnalysisOverviewPoint = {
  label: string;
  score: number;
  calls: number;
};

export enum CallOverviewScoreKey {
  PAIN = "pain",
  OBJECTION = "objection",
  BUYING_SIGNAL = "buyingSignal",
  CONVERSATION_CLARITY = "conversationClarity",
  PROSPECT_ENGAGEMENT = "prospectEngagement",
  NEXT_STEP_CLARITY = "nextStepClarity",
}

export type CallAnalysisOverviewScore = {
  key: CallOverviewScoreKey;
  value: number;
};

export type CallAnalysisOverviewTopic = {
  label: string;
  type: string;
  level: ProjectCallsInsightLevel | null;
  calls: number;
};

export type CallAnalysisOverviewType = {
  type: string;
  calls: number;
};

export type CallAnalysisOverviewMember = {
  name: string;
  score: number;
  calls: number;
};

export type CallAnalysisOverview = {
  analysedCalls: number;
  totalCalls: number;
  durationSeconds: number;
  globalScore: number | null;
  previousGlobalScore: number | null;
  avgQuestions: number | null;
  timeline: CallAnalysisOverviewPoint[];
  scores: CallAnalysisOverviewScore[];
  topInsights: CallAnalysisOverviewTopic[];
  topPatterns: CallAnalysisOverviewTopic[];
  members: CallAnalysisOverviewMember[];
  types: CallAnalysisOverviewType[];
};
